import { render, staticRenderFns } from "./callio-config.vue?vue&type=template&id=7154ce70"
import script from "./callio-config.vue?vue&type=script&lang=js"
export * from "./callio-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports